module.exports = __webpack_public_path__ + "img/carousel-image1.960ec5bf.png";